import HeaderDialog from 'components/foundation/dialogs/HeaderDialog/HeaderDialog';
import { ClassName } from 'types/ClassName';
import { t } from 'utils/localize';
import EquipmentCreateForm from '../EquipmentCreateForm/EquipmentCreateForm';

export interface IEquipmentCreateFormDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data?: string) => void;
  className?: ClassName;
}

const EquipmentCreateFormDialog = (props: IEquipmentCreateFormDialogProps) => {
  const { className, isOpen, onClose, onSubmit } = props;

  return (
    <HeaderDialog className={className} isOpen={isOpen} title={t('Create Equipment')} onClose={onClose} divider={false}>
      <EquipmentCreateForm onSubmit={onSubmit} />
    </HeaderDialog>
  );
};

export default EquipmentCreateFormDialog;
